module.exports = __webpack_public_path__ + "media/images/flags/64/Turkmenistan-fb1ef72e3d43f8a28e83f7de328ef821.png";